/**
 * Wire-format schema for `wp/v2/eztag`.
 *
 * Tags are flat (no parent), so the surface is simpler than categories.
 * Carbon Fields' `crb_tag_color` rides along at the top level of every
 * REST response — same convention as the other taxonomies.
 */
import { z } from 'zod'

import { type Tag } from '@/entities/tag'
import { htmlToPlain } from '@/shared/lib/html'

const TagWireSchema = z
  .object({
    id: z.number().int().positive(),
    name: z.string(),
    slug: z.string(),
    count: z.number().int().nonnegative().default(0),
    // Same Carbon Fields surfacing pattern as on ezdish / ezmod /
    // ezcategory — top-level string, not in OPTIONS schema.
    crb_tag_color: z.string().optional().default(''),
    // Top-level — see `categories.ts` for the full note on this field.
    term_order: z.number().int().nonnegative().optional().default(0),
  })
  .transform(
    (raw): Tag => ({
      id: raw.id,
      name: htmlToPlain(raw.name),
      slug: raw.slug,
      count: raw.count,
      color: raw.crb_tag_color,
      termOrder: raw.term_order,
    }),
  )

export const tagWire = TagWireSchema
export const tagListWire = z.array(TagWireSchema)
